import React, { useEffect, useState, setGlobal } from 'reactn';
import onChange from 'on-change';
import { isIE } from 'react-device-detect';
import usePageData from './components/shared/usePageData.js';
import {
  convertVariables,
  devOrProd,
  isDev,
  useTailwindMediaQuery
} from './components/shared/utils';

import Banner from './components/Banner';
import PromoEventCutoff from './components/BannerTimer/index.js';
import CategoriesBrands from './components/BlackFriday/categories-brands.jsx';
import BrandFocus from './components/BrandFocus';
import BrandList from './components/BrandList';
import BrandStory from './components/BrandStory';
import CreativeFeature from './components/CreativeFeature';
import CreativeFeatureVideo from './components/CreativeFeature/Video';
import CreativeFeatureSlider from './components/CreativeFeatureSlider';
import Editorial from './components/Editorial';
import Hero from './components/Hero';
import HeroVideo from './components/HeroVideo/HeroVideo';
import HeroVideoBackground from './components/HeroVideoBackground';
import HeroWithText from './components/HeroWithText';
import NewArrivals from './components/NewArrivals';
import Outfits from './components/Outfits/index.js';
import RaffleSlider from './components/RaffleSlider';
import Storyly from './components/Storyly';
import TitleAndText from './components/TitleAndText';

import './styles/app.scss';
import { showMonetateTests } from './components/shared/monetateTests.js';
import Redesign from './redesign/Redesign.jsx';

// Set global monetate var
window.showMonetateTests = showMonetateTests;

// Set Global State
setGlobal(window.showMonetateTests);

if (!isIE) {
  window.changeGlobalState = onChange(
    window.showMonetateTests,
    function (path, value, previousValue) {
      //console.log('Updating global state');
      setGlobal({ ...window.showMonetateTests });
    }
  );
}

// Set window variables
window.nqInstance = 0;
window.scrollLock = () => {
  const scrollLock = document.querySelector('body');
  scrollLock.classList.toggle('scroll-lock');
};

const App = () => {
  const [userSession] = useState(window.location.search);
  const [componentData, setComponentData] = useState({});
  const [rebuildComponentData, setRebuildComponentData] = useState();
  const isMobile = useTailwindMediaQuery('md');
  const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname === 'localhost';

  // GET DATA FROM NQ
  const pageParams = usePageData(
    window.changeGlobalState.homepageRebuild2026
      ? 'seven-homepage-redesign-2026'
      : 'seven-homepage-landing-page',
    '0',
    'pages'
  );

  // API DATA
  useEffect(() => {
    if (
      pageParams &&
      pageParams.data &&
      window.changeGlobalState.homepageRebuild2026
    ) {
      let content = pageParams.data.content.content;

      convertVariables(content);
      setRebuildComponentData(content);
    } else if (
      pageParams &&
      pageParams.data &&
      !window.changeGlobalState.homepageRebuild2026
    ) {
      let content = pageParams.data.content.content;

      convertVariables(content);

      let tempComponentData = {
        hero: content[1].data.block_reference, // component 1
        titleAndText: content[2].data, // component 2
        creativeFeature: content[3].data.block_reference, // component 3
        editorialFeature: content[4].data.block_reference, // component 4
        editorialCards: content[5].data.block_reference, // component 5
        brandFocus: content[6].data.block_reference, // component 6
        brandStory: content[7].data.block_reference, // component 7
        hero3: content[0].data.block_reference, // component 8
        editorialFeature2: content[8].data.block_reference, // component 9
        heroVideo: content[10].data.seven_video_hero_container, // component 10
        heroWithText: content[11].data.seven_black_friday_container, // component 11
        creativeFeatureVideo: content[12].data, // component 12
        creativeFeatureVideo2: content?.[22].data, // component 12a
        creativeFeature2: content[13].data.block_reference, // component 13
        creativeFeatureSlider: content[14].data, // component 14
        creativeFeatureSlider2: content[15].data, // component 15
        hero2: content[9].data.block_reference, // component 16
        bfCategories: content[16].data, // component 16
        bfBrands: content[17].data, // component 17
        launchesPrio: content[18].data.skus, // component 18
        editorialFeature3: content[20].data.block_reference, // component 19
        creativeCampaignReplacement: content[19].data.block_reference, // component 20
        outfits: content?.[21]?.data || [] // component 21
      };
      setComponentData(tempComponentData);
    }
  }, [pageParams]);

  return window.changeGlobalState.homepageRebuild2026 ? (
    <Redesign data={rebuildComponentData} />
  ) : (
    <section className="font-sans text-base font-base tracking-widest">
      {/* Fix to remove extra spacing on test site */}
      {devOrProd === 'dev' && (
        <style>
          {'div.main:not(.localhost) {padding-top: 11px !important;}'}
        </style>
      )}

      {/* Summer 20 Banner */}
      {/* <Banner
        student20={true}
        hideQr={true}
        blackFridayPreview={true}
        gradient={false}
        clickable={true}
        link="/summer-20-off-/"
        gaBlockTitle="Summer 20% Off Banner Button"
        gaBlockName="Summer 20% Off"
        gaBlockId="summer-20-off-banner-button"
        endSale25ExtraImg="https://www.sevenstore.com/images/src/seven/summer20/lockup.webp"
        endSale25ExtraAlt="Summer 20% Off"
        endSale25ExtraClasses={'relative !w-11/12 md:!w-4/5'}
        className="banner-summer-20 !gap-14 !aspect-[3/1] xl:!aspect-[4/1]"
      /> */}

      <Hero
        data={componentData.hero}
        gaBlockName={'Hero Carousel'}
        topMargin={false}
        singleHero={true}
        autoplay={false}
        showHero={true}
        salePromo={false}
        heroOptions={{
          classes: 'hero-1 mt-12 lg:mt-12'
        }}
      />

      {/* Component 3 - CREATIVE FEATURE - 1 */}
      <CreativeFeature
        data={componentData.creativeFeature}
        gaBlockName={'Brand Strip'}
        creativeFeatureOptions={{
          classes: 'creative-feature-1 lg:!my-32'
        }}
        showCreativeFeature={true}
      />

      <Banner
        cta="15% Off Full Price"
        description="APP EXCLUSIVE WITH CODE: APP15"
        disclaimer={true}
        disclaimerText="*Selected Lines Only"
        app20off={true}
        gaBlockName="25% Off Footwear"
        className="items-start justify-between md:items-center md:h-[260px]"
      />

      {/* BRAND LIST */}
      <BrandList
        gaBlockName={'Brand'}
        blackFriday={true}
        brandListOptions={{
          classes: 'brand-list-1 mb-40 lg:mb-48'
        }}
      />

      {/*<Banner
        className="banner-app-20-off !h-[400px] lg:!h-[35rem] !p-0 gap-20 !items-center !justify-center"
        endSaleThin={true}
        gradient={false}
        hideQr={true}
        link="/25-off-footwear/"
        gaBlockTitle="20% Off App Only"
        gaBlockName="20% Off App Only"
        gaBlockId="20-off-app-only-banner-button"
        endSale25ExtraImg="https://fa-ecom.s3.eu-west-2.amazonaws.com/seven/SS_WK38_APP20_Part1_Homepage_Copy.webp"
        endSale25ExtraAlt="20% Off App Only"
        endSale25ExtraClasses={'relative !w-11/12 md:!w-3/5 xl:!w-8/12'}
        appBannerOptions={{
          classes: '!mt-8 !mb-28 md:!mt-24 md:!mb-36'
        }}
      /> */}

      <NewArrivals
        gaBlockName={'New In Carousel'}
        gaBlockNameClothing={'New In Clothing'}
        gaBlockNameFootwear={'New In Footwear'}
        gaBlockNameAccessories={'New In Accessories'}
        newArrivalsHeading={'New In'}
        newArrivalsOptions={{
          classes: 'black-friday-top-selects-1 !my-0 !mb-20'
        }}
        // blackFriday={true}
        // blackFridayBadge={'Sale'}
        // badgeClasses="!bg-[#d70000]"
        isSeventhImage={false}
        newArrivalsButtonLinkAll={'/latest/'}
        newArrivalsButtonLinkClothing={
          'https://www.sevenstore.com/mens-clothing/'
        }
        newArrivalsButtonLinkFootwear={'https://www.sevenstore.com/footwear/'}
        newArrivalsButtonLinkAcc={
          'https://www.sevenstore.com/mens-accessories/accessories/'
        }
        newArrivalsAllFeed={'nq-new-arrivals-all-feed'}
        newArrivalsClothingFeed={'nq-new-arrivals-clothing-feed'}
        newArrivalsFootwearFeed={'nq-new-arrivals-footwear-feed'}
        newArrivalsAccessoriesFeed={'nq-new-arrivals-accessories-feed'}
      />

      {/* <Hero
        data={componentData.hero}
        gaBlockName={'Hero Carousel'}
        topMargin={false}
        singleHero={true}
        autoplay={false}
        showHero={true}
        salePromo={false}
        heroOptions={{
          classes: 'hero-1 mt-12 lg:mt-12'
        }}
      /> */}

      <Hero
        data={componentData.hero2}
        gaBlockName={'Hero Carousel 2'}
        topMargin={false}
        singleHero={true}
        autoplay={false}
        showHero={true}
        salePromo={false}
        heroOptions={{
          classes: 'hero-2 mt-12 lg:mt-12'
        }}
      />

      {/* Component 4 - EDITORIAL - FEATURE LARGE 1 */}
      <Editorial
        data={componentData.editorialFeature}
        gaBlockName={'Feature Large'}
        featureLayout={true}
        showFeatureLayoutEditorial={true}
        topMargin={false}
        featureLayoutOptions={{
          classes: 'editorial-large-1 !mb-16 lg:!mb-32'
        }}
        lazyLoad={false}
      />

      {/* Component 20 - CREATIVE FEATURE */}
      <CreativeFeature
        data={componentData.creativeCampaignReplacement}
        gaBlockName={'Brand Strip'}
        creativeFeatureOptions={{
          classes: 'creative-feature-1 lg:!my-32'
        }}
        showCreativeFeature={true}
      />

      {/* Component 21 - GET THE LOOK */}
      {isDev && (
        <Outfits data={componentData.outfits} userSession={userSession} />
      )}

      {/* Component 22 - BANNER */}
      <Banner
        cta={'stay in the know.'}
        salePromo={true}
        description={
          <div className="flex flex-col gap-4">
            <p className="font-bold">
              15% off your first order when you sign up to our newsletter.
            </p>
            <p>
              Get more exclusive offers, LAUNCHES and product releases when you
              sign up for our newsletter and download our app.
            </p>
          </div>
        }
        input={true}
        inputPlaceholder={'SUBSCRIBE.'}
        appBannerOptions={{
          classes: 'app-banner-1 lg:mt-32'
        }}
      />

      {devOrProd === 'dev' && (
        <RaffleSlider data={componentData.launchesPrio} />
      )}

      {/* ---------- EVERYTHING BELOW IS FOR STAGING TESTING ---------- */}
      {devOrProd === 'dev' && isLocalhost && (
        <>
          <div className="flex flex-col justify-center items-center py-20 md:py-32 mb-24 lg:mb-32 bg-blackFriday1">
            <h2 className="text-black font-extrabold text-2xl md:text-3xl lg:text-4xl text-center">
              See below for all additional components - currently not in use
            </h2>
          </div>

          {/* Component 14 - CREATIVE FEATURE - SLIDER 1 - RIGHT */}
          <CreativeFeatureSlider
            data={componentData.creativeFeatureSlider}
            gaBlockName={'Creative Feature Slider'}
            creativeFeatureSliderOptions={{
              classes: 'creative-feature-slider md:!my-44'
            }}
            showCreativeFeatureSlider={true}
            sliderRight={true}
            singleHero={false}
          />
          {/* HERO - HERO 1 */}
          <Hero
            data={componentData.hero}
            gaBlockName={'Hero Carousel'}
            topMargin={false}
            singleHero={true}
            autoplay={false}
            showHero={true}
            salePromo={false}
            heroOptions={{
              classes: 'hero-1 mt-12 lg:mt-32'
            }}
          />
          {/* Component 12 - CREATIVE FEATURE - VIDEO */}
          <CreativeFeatureVideo
            data={componentData.creativeFeatureVideo}
            gaBlockName={'Brand Strip'}
            creativeFeatureVideoOptions={{
              classes: 'mt-12 lg:mt-32'
            }}
            showCreativeFeatureVideo={true}
          />

          {/* Component 12a - CREATIVE FEATURE - VIDEO 2 */}
          <CreativeFeatureVideo
            data={componentData.creativeFeatureVideo2}
            gaBlockName={'Brand Strip'}
            creativeFeatureVideoOptions={{
              classes: 'mt-12 lg:mt-32'
            }}
            showCreativeFeatureVideo={true}
          />

          {/* END OF SEASON SALE COMPONENTS */}
          <div className="flex flex-col gap-14 md:gap-28 pb-20 md:pb-32 mb-24 lg:mb-32 bg-blackFriday1">
            <Banner
              blackFridayPreview={true}
              blackFriday24={true}
              promoLockup2={true}
              buttonLink={'https://www.sevenstore.com/sale/apparel/'}
              buttonLink2={'https://www.sevenstore.com/sale/footwear/'}
              buttonLink3={'https://www.sevenstore.com/sale/accessories/'}
              buttonLink4={'https://www.sevenstore.com/sale/'}
              buttonLinkText={'Sale Clothing'}
              buttonLinkText2={'Sale Footwear'}
              buttonLinkText3={'Sale Accessories'}
              buttonLinkText4={'All Sale'}
              gaBlockTitle="70% Off End of Season Sale Banner Button"
              gaBlockName="70% Off End of Season Sale"
              gaBlockId="70-off-end-of-season-sale-banner-button"
              endSale25ExtraImg="https://fa-ecom.s3.eu-west-2.amazonaws.com/images/sevenstore/homepage/SS_EOS_XTRA15_HOMEPAGE_500x640+1.png"
              endSale25ExtraAlt="70% Off End of Season Sale"
              endSale25ExtraClasses={'relative !w-full md:!w-3/5 xl:!w-8/12'}
              resetAspect={true}
              gradient={false}
              buttonAbsolute={false}
              className="banner-eos-40-off w-full !gap-20 [aspect-ratio:auto_!important]"
              imageClasses="md:py-20"
            />

            <CategoriesBrands
              data={componentData.bfCategories}
              gaBlockName={'Black Friday Categories'}
              categoryBrandOptions={{
                classes: 'categories-1'
              }}
              showCategoryBrand={true}
            />

            <CategoriesBrands
              data={componentData.bfBrands}
              gaBlockName={'Black Friday Brands'}
              categoryBrandOptions={{
                classes: 'brands-1'
              }}
              showCategoryBrand={true}
            />
          </div>

          {/* BANNER - 25% OFF FOOTWEAR */}
          <Banner
            student20={true}
            hideQr={true}
            blackFridayPreview={true}
            gradient={false}
            clickable={true}
            link="/25-off-footwear/"
            buttonLink="25-off-footwear/"
            buttonLinkText="Shop Now"
            gaBlockTitle="25% Off Footwear Banner Button"
            gaBlockName="25% Off Footwear"
            gaBlockId="25-off-footwear-banner-button"
            endSale25ExtraImg="https://www.sevenstore.com/images/src/images/sevenstore/homepage/SS_WK19_Website_25OFF_Footwear_App_Site_2048x1228_COPY.webp"
            endSale25ExtraAlt="25% Off Footwear"
            endSale25ExtraClasses="relative !w-full md:!w-3/5 xl:!w-1/2 md:-top-12 xl:-top-32"
            className="banner-app-20-off !gap-14 !aspect-[3/1] xl:!aspect-[4/1]"
          />

          {/* BANNER - 25% OFF FOOTWEAR */}
          <Banner
            className="banner-app-20-off !h-96 lg:!h-[35rem] !p-0 gap-20 !items-center !justify-center"
            endSaleThin={true}
            gradient={false}
            hideQr={true}
            clickable={true}
            link="/25-off-footwear/"
            buttonLink="25-off-footwear/"
            buttonLinkText="Shop Now"
            gaBlockTitle="25% Off Footwear Banner Button"
            gaBlockName="25% Off Footwear"
            gaBlockId="25-off-footwear-banner-button"
            endSale25ExtraImg="https://www.sevenstore.com/images/src/images/sevenstore/homepage/SS_WK19_Website_25OFF_Footwear_App_Site_2048x1228_COPY.webp"
            endSale25ExtraAlt="25% Off Footwear"
            endSale25ExtraClasses={
              'relative md:-top-16 !w-11/12 md:!w-3/5 xl:!w-5/12'
            }
            appBannerOptions={{
              classes: '!mt-8 !mb-28 md:!mt-24 md:!mb-36'
            }}
          />

          {/* BANNER - 25% Discount (Footwear) */}
          <Banner
            cta="25% Off Footwear"
            description="Use Code: 25OFF"
            clickable={true}
            link="/25-off-footwear/"
            buttonLink="25-off-footwear/"
            buttonLinkText="Shop Now"
            promoPercentoff={true}
            promoPercentoffBG="banner-app-20-off"
            promoPercentoffColor="text-white"
            gaBlockTitle="25% Off Footwear Banner Button"
            gaBlockName="25% Off Footwear"
            gaBlockId="25-off-footwear-banner-button"
            buttonColour="white"
            className="items-start justify-between md:items-center md:h-80"
          />

          {/* Component 15 - CREATIVE FEATURE - SLIDER 2 - LEFT */}
          <CreativeFeatureSlider
            data={componentData.creativeFeatureSlider2}
            gaBlockName={'Creative Feature Slider'}
            creativeFeatureSliderOptions={{
              classes: 'creative-feature-slider-2'
            }}
            showCreativeFeatureSlider={true}
            sliderRight={false}
            singleHero={false}
          />

          {/* Component 5 - EDITORIAL - FEATURE SMALL */}
          <Editorial
            data={componentData.editorialCards}
            gaBlockName={'Feature Small'}
            showSmallLayout={true}
            smallLayoutOptions={{
              classes: 'editorial-small-1 lg:!my-36'
            }}
          />

          {/* BANNER - 20% OFF FULL PRICE */}
          <Banner
            student20={true}
            hideQr={true}
            blackFridayPreview={true}
            gradient={false}
            clickable={true}
            link="/save-20-/"
            buttonLink="save-20-/"
            buttonLinkText="Shop Now"
            gaBlockTitle="20% Off Full Price Banner Button"
            gaBlockName="20% Off Full Price"
            gaBlockId="20-off-full-price-banner-button"
            endSale25ExtraImg="https://www.sevenstore.com/images/src/images/sevenstore/homepage/SS_WK17_Website_20OFF_Homepage_Lockup1.webp"
            endSale25ExtraAlt="20% Off Full Price"
            endSale25ExtraClasses="relative !w-full md:!w-3/5 xl:!w-7/12 md:-top-10 lg:-top-12 xl:-top-20"
            className="banner-app-20-off !gap-20 !aspect-[1/1] md:!aspect-[2/1] xl:!aspect-[3/1]"
          />

          {/* BANNER - MSS PROMO */}
          <Banner
            className="banner-mss !h-fit md:!h-96 lg:!h-[35rem] !p-0 gap-20 !items-center !justify-center"
            endSaleThin={true}
            gradient={false}
            hideQr={true}
            clickable={true}
            link="/sale/"
            buttonLink={'sale/'}
            buttonLinkText={'Shop Now'}
            gaBlockTitle={'Mid Season Sale Banner'}
            gaBlockName={'Mid Season Sale Banner Button'}
            gaBlockId={'mid-season-sale-banner-button'}
            endSale25ExtraImg="https://www.sevenstore.com/images/src/seven/banners/mid-season-60-off-lockup-1.png"
            endSale25ExtraAlt="Mid Season Sale"
            endSale25ExtraClasses={
              'relative md:-top-10 pt-10 md:pt-0 !w-11/12 md:!w-3/5 xl:!w-6/12'
            }
          />

          {/* EDITORIAL - FEATURE LARGE 2 */}
          <Editorial
            data={componentData.editorialFeature2}
            gaBlockName={'Feature Large'}
            featureLayout={true}
            showFeatureLayoutEditorial={true}
            featureLayoutOptions={{
              classes: 'my-20 lg:my-36'
            }}
          />

          <Banner
            className="banner-bf-preview !h-fit md:!h-96 lg:!h-[35rem] !p-0 gap-20 !items-center !justify-center"
            endSaleThin={true}
            hideQr={true}
            clickable={true}
            link="/sale/"
            buttonLink={'sale/'}
            buttonLinkText={'Shop Now'}
            gaBlockTitle={'End of Season Sale Banner'}
            gaBlockName={'End of Season Sale Banner Button'}
            gaBlockId={'end-of-season-sale-banner-button'}
            endSale25ExtraImg="https://www.sevenstore.com/images/src/images/sevenstore/sale/eos-final-extra-15.webp"
            endSale25ExtraAlt="End of Season Sale"
            endSale25ExtraClasses={
              'relative md:-top-14 pt-10 md:pt-0 !w-11/12 md:!w-3/5 xl:!w-6/12'
            }
          />

          {/* BANNER - HOKA PROMO */}
          <Banner
            cta="Extra 25% Off Hoka"
            description="Use Code: HOKA25"
            clickable={true}
            link="/25-off-hoka/"
            buttonLink="25-off-hoka/"
            buttonLinkText="Shop Now"
            promoPercentoff={true}
            promoPercentoffBG="banner-25-hoka"
            promoPercentoffColor="text-white"
            gaBlockTitle="Extra 25% Off Hoka Banner Button"
            gaBlockName="Extra 25% Off Hoka"
            gaBlockId="extra-25-off-hoka-banner-button"
            buttonColour="white"
            className="items-start justify-between md:items-center md:h-80"
          />

          {/* BANNER - XMAS CUTOFF */}
          <PromoEventCutoff
            gaBlockName="Delivery Cutoff Promo - UK HP - DEC 2025"
            //containerLink="/help-hub/#/delivery-uk"
            wrapperClass="my-20 lg:mt-24 lg:mb-32"
            fullWidth={false}
            cutoff={'Dec 23, 2025'}
            time={'16:00'}
            title={'Last Chance!'}
            subCopy={'Get it for'}
            subCopy2={'Christmas'}
            nextDay={true}
            showTimer={true}
            // Standard & NDD
            //desktopImage="https://www.sevenstore.com/images/src/images/sevenstore/christmas/cutoff/xmas-cutoff-std-desk.webp"
            //mobileImage="https://www.sevenstore.com/images/src/images/sevenstore/christmas/cutoff/xmas-cutoff-std-mob.webp"
            //desktopImage2="https://www.sevenstore.com/images/src/images/sevenstore/christmas/cutoff/xmas-cutoff-ndd-desk.webp"
            //mobileImage2="https://www.sevenstore.com/images/src/images/sevenstore/christmas/cutoff/xmas-cutoff-ndd-mob.webp"
            // Guaranteed
            desktopImage="https://www.sevenstore.com/images/src/images/sevenstore/christmas/cutoff/xmas-cutoff-desk-2.webp"
            mobileImage="https://www.sevenstore.com/images/src/images/sevenstore/christmas/cutoff/xmas-cutoff-mob-2.webp"
          />

          {/* HERO - HERO 3 - GIFTING */}
          <Hero
            data={componentData.hero3}
            gaBlockName={'Hero Carousel 3'}
            topMargin={false}
            singleHero={true}
            autoplay={false}
            showHero={true}
            salePromo={false}
            heroOptions={{
              classes: 'hero-3'
            }}
          />

          {/* BANNER - XMAS RETURS */}
          <Banner
            cta={'Extended Festive Returns'}
            description={
              <>
                Exchange or return until{' '}
                <span className="font-bold">5th January 2026.</span>
              </>
            }
            clickable={true}
            link="/help-hub/#/returns/"
            buttonLink={'help-hub/#/returns/'}
            buttonLinkText={'More Info'}
            xmasReturns={true}
            gaBlockTitle={'Extended Festive Returns Banner Button'}
            gaBlockName={'Extended Festive Returns'}
            gaBlockId={'extended-festive-returns-banner-button'}
            buttonColour={'whiteSolid'}
            className={'items-start justify-between md:items-center md:h-80'}
          />

          {/* APP BANNER - BLACK FRIDAY PREVIEW */}
          <Banner
            cta={'Black Friday Preview'}
            bfpDescription={'25% OFF'}
            bfpDescription2={'with code'}
            bfpDescription3={'BF25'}
            description2={'App Exclusive'}
            blackFridayPreview={true}
            DowloadCopy={'Download the Sevenstore App'}
          />

          {/* BANNER - 25% OFF FOOTWEAR */}
          <Banner
            className="banner-25-off-footwear !h-fit md:!h-96 lg:!h-[35rem] !p-0 gap-10 !items-center !justify-center"
            promoLockup={true}
            hideQr={true}
            clickable={true}
            link="/25-off-footwear/"
            buttonLink={'25-off-footwear/'}
            buttonLinkText={'Shop Now'}
            gaBlockTitle={'25% Off Footwear Banner'}
            gaBlockName={'25% Off Footwear Banner Button'}
            gaBlockId={'25-off-footwear-banner-button'}
            endSale25={false}
            endSale25Extra={false}
            endSale25ExtraImg="https://www.sevenstore.com/images/src/images/sevenstore/homepage/SS_25_FTWR_SALE_HP_LOCKUP.webp"
            endSale25ExtraAlt="25% Off Footwear"
            endSale25ExtraClasses={
              'relative top-8 md:-top-14 !w-full md:!w-3/5 xl:!w-5/12'
            }
            appBannerOptions={{
              classes: '!max-w-none !px-0 !mt-0 lg:!mb-36'
            }}
            highlightedText={true}
            highlightedTextProps={{
              type: 'flash-in-out',
              containerClassName:
                'absolute inset-0 top-32 md:top-10 lg:top-20 flex items-start justify-center',
              textClassName:
                'tracking-tight font-times text-purplePromo font-bold text-4xl lg:text-6xl'
            }}
            cta="LIMITED TIME ONLY"
          />

          {/* BRAND FOCUS */}
          <BrandFocus
            brandFocusData={componentData.brandFocus}
            brandFocusFeed={'nq-brand-focus-feed'}
            heroGaBlockName={'Category Focus'}
            carouselGaBlockName={'Category Carousel'}
            showBrandFocus={true}
            brandFocusOptions={{
              classes: 'brand-focus lg:!my-32'
            }}
          />

          {/* STUDENTDISCOUNT BANNER */}
          <Banner
            className="banner-students-key-workers !h-fit !p-0 gap-10 !items-center !justify-center"
            student20={true}
            hideQr={true}
            clickable={true}
            link="/student--key-worker-collection/"
            buttonLink={'student-discount/'}
            buttonLinkText={'Students Code'}
            buttonLink2={'key-worker-discount/'}
            buttonLinkText2={'Key Workers Code'}
            buttonLink3={'student--key-worker-collection/'}
            buttonLinkText3={'Shop Now'}
            gaBlockTitle={'Students 20% Off Full Price Banner'}
            gaBlockName={'Students 20% Off Full Price Banner Button'}
            gaBlockId={'students-20-off-full-price-banner-button'}
            endSale25={false}
            endSale25Extra={false}
            endSale25ExtraImg="https://www.sevenstore.com/images/src/images/sevenstore/homepage/SS_STUDENT_PROMO_HOMEPAGE_LOCKUP.webp"
            endSale25ExtraAlt="Students 20% Off Full Price"
            endSale25ExtraClasses={
              'relative md:-top-14 !w-full md:!w-1/2 lg:!w-3/5'
            }
          />

          {/* DISCOUNT BANNER */}
          <Banner
            cta={'20% Off Full Price'}
            description={'USE CODE: SAVE20'}
            disclaimer={true}
            disclaimerText="*Selected Lines Only."
            hideQr={true}
            clickable={true}
            link="/student--key-worker-collection/"
            className="banner-students-key-workers !h-fit !p-0 gap-10 !items-center !justify-center"
            gaBlockTitle={'Students 20% Off Full Price Banner'}
            gaBlockName={'Students 20% Off Full Price'}
            gaBlockId={'students-20-off-full-banner-button'}
            student20={true}
            endSale25ExtraImg="https://www.sevenstore.com/images/src/images/sevenstore/homepage/SS_STUDENT_PROMO_HOMEPAGE_LOCKUP.webp"
            endSale25ExtraAlt="Students 20% Off Full Price"
            endSale25ExtraClasses={'!w-11/12 md:!w-1/2 lg:!w-3/5'}
          />

          {/* END OF SEASON SALE */}
          <div className="flex flex-col gap-14 md:gap-28 pb-20 md:pb-32 mb-24 lg:mb-32 bg-blackFriday1">
            <Banner
              cta={'END OF SEASON SALE'}
              bfpDescription={'FINAL REDUCTIONS'}
              bfpDescription2={'MORE LINES ADDED'}
              blackFridayPreview={true}
              blackFriday24={true}
              buttonLink={'student-discount/'}
              buttonLinkText={'Students Code'}
              buttonLink2={'key-worker-discount/'}
              buttonLinkText2={'Key Workers Code'}
              buttonLink3={'sale/'}
              buttonLinkText3={'Shop Now'}
              gaBlockTitle={'End of Season Sale Banner Button'}
              gaBlockName={'End of Season Sale'}
              gaBlockId={'end-of-season-sale-banner-button'}
              endSale25={true}
              endSale25ExtraTextOnly={true}
            />

            <CategoriesBrands
              data={componentData.bfCategories}
              gaBlockName={'New In Categories'}
              categoryBrandOptions={{
                classes: 'categories-1'
              }}
              showCategoryBrand={true}
            />

            <CategoriesBrands
              data={componentData.bfBrands}
              gaBlockName={'End of Season Sale Brands'}
              categoryBrandOptions={{
                classes: 'brands-1'
              }}
              showCategoryBrand={true}
            />

            <NewArrivals
              gaBlockName={'End of Season Sale Carousel'}
              gaBlockNameClothing={'End of Season Sale Carousel Clothing'}
              gaBlockNameFootwear={'End of Season Sale Carousel Footwear'}
              gaBlockNameAccessories={'End of Season Sale Carousel Accessories'}
              newArrivalsHeading={'End of Season Sale Top Selects'}
              newArrivalsOptions={{
                classes: 'black-friday-top-selects-1 !my-0'
              }}
              blackFriday={true}
              blackFridayBadge={'End of Season Sale'}
              isSeventhImage={false}
              newArrivalsButtonLinkAll={'//black-friday-offers//'}
              newArrivalsButtonLinkClothing={
                '/black-friday-offers/?category_default_codes=am'
              }
              newArrivalsButtonLinkFootwear={
                '/black-friday-offers/?category_default_codes=fm'
              }
              newArrivalsButtonLinkAcc={
                '/black-friday-offers/?category_default_codes=cm'
              }
              newArrivalsAllFeed={'nq-new-arrivals-all-feed'}
              newArrivalsClothingFeed={'nq-new-arrivals-clothing-feed'}
              newArrivalsFootwearFeed={'nq-new-arrivals-footwear-feed'}
              newArrivalsAccessoriesFeed={'nq-new-arrivals-accessories-feed'}
            />
          </div>

          {/* BRAND STORY */}
          <BrandStory
            brandStoryData={componentData.brandStory}
            brandStoryFeed={'nq-brand-story-feed'}
            gaBlockName={'Product Focus'}
            showBrandStory={true}
            brandStoryOptions={{
              classes: 'brand-story lg:!my-32'
            }}
          />

          {/* HERO - HERO 2 */}
          <Hero
            data={componentData.hero2}
            gaBlockName={'Hero Carousel 2'}
            topMargin={false}
            singleHero={true}
            autoplay={false}
            showHero={true}
            salePromo={true}
            heroOptions={{
              classes: 'hero-2'
            }}
          />

          {/* HERO - VIDEO BACKGROUND */}
          <HeroVideoBackground
            data={componentData.heroVideo}
            gaBlockName={'Hero Video'}
            topMargin={false}
            isLoop={true}
            isAutoPlay={true}
            isControls={false}
            isMuted={true}
            showHeroVideoBackground={true}
            salePromo={true}
            heroVideoOptions={{
              classes: 'hero-video'
            }}
            heroVideoAspect={{
              classes: '!aspect-[1/1] md:!aspect-[3/1]'
            }}
            clickOnBanner={true}
          />

          {/* HERO - WITH TEXT OVERLAY */}
          <HeroWithText
            data={componentData.heroWithText}
            gaBlockName={'Hero Carousel'}
            topMargin={false}
            singleHero={true}
            showHeroWithText={true}
            thinStrip={true}
            extraThinStrip={false}
            heroWithTextOptions={{
              classes: 'hero-with-text mb-16 lg:mb-32'
            }}
          />

          <div className="flex flex-col justify-center items-center py-20 lg:mb-32 bg-blackFriday1">
            <h2 className="text-black font-extrabold text-2xl md:text-3xl lg:text-4xl text-center">
              Click 'View More' on the below component for video popup
            </h2>
          </div>
          {/* HERO - VIDEO POPUP */}
          <HeroVideo
            data={componentData.heroVideo}
            gaBlockName={'Hero Video - Modal'}
            topMargin={false}
            showHeroVideo={true}
          />

          {/* CREATIVE FEATURE - 2 */}
          <CreativeFeature
            data={componentData.creativeFeature2}
            gaBlockName={'Brand Strip'}
            creativeFeatureOptions={{
              classes: 'creative-feature-2'
            }}
            showCreativeFeature={true}
          />

          {/* STORYLY */}
          <Storyly
            storylyToken="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhY2NfaWQiOjU3NzcsImFwcF9pZCI6MTE0NTUsImluc19pZCI6MTIyMzR9.b-keMHACgsvKeHCC2qumUjcZop550-rWBcKjeM-J42A"
            storylyHeading="Sevenstore Stories"
            showHeading={false}
            storylyOptions={{
              classes: 'storyly-1 !mt-52'
            }}
          />

          {/* TITLE AND TEXT */}
          <TitleAndText
            data={componentData.titleAndText}
            showTitleText={true}
          />

          {/* APP BANNER - 20% Discount */}

          {/* CYBER WEEK COMPONENTS */}
          <div className="flex flex-col gap-14 md:gap-28 pb-20 md:pb-32 mb-24 lg:mb-32 bg-blackFriday1">
            <Banner
              cta={'Cyber Week'}
              bfpDescription={'25% OFF'}
              bfpDescription2={'with code'}
              bfpDescription3={'BF25'}
              blackFridayPreview={true}
              blackFriday24={true}
              buttonLink={'black-friday-offers/'}
              buttonLinkText={'Shop Now'}
              gaBlockTitle={'Cyber Monday Banner Button'}
              gaBlockName={'Cyber Monday Offers'}
              gaBlockId={'cyber-monday-banner-button'}
              cyberMonday24={true}
              cyberMonday24BGVid={
                isMobile
                  ? 'https://www.sevenstore.com/images/src/images/sevenstore/cyber-monday/CyberWeek-Mob-3.webm'
                  : 'https://www.sevenstore.com/images/src/images/sevenstore/cyber-monday/CyberWeek-Desk-3.webm'
              }
              cyberMonday24BGVidType={'video/webm'}
            />

            <CategoriesBrands
              data={componentData.bfCategories}
              gaBlockName={'Cyber Week Categories'}
              categoryBrandOptions={{
                classes: 'categories-1'
              }}
              showCategoryBrand={true}
            />

            <CategoriesBrands
              data={componentData.bfBrands}
              gaBlockName={'Cyber Week Brands'}
              categoryBrandOptions={{
                classes: 'brands-1'
              }}
              showCategoryBrand={true}
            />

            <NewArrivals
              gaBlockName={'Cyber Week Carousel'}
              gaBlockNameClothing={'Cyber Week Carousel Clothing'}
              gaBlockNameFootwear={'Cyber Week Carousel Footwear'}
              gaBlockNameAccessories={'Cyber Week Carousel Accessories'}
              newArrivalsHeading={'Cyber Week Top Selects'}
              newArrivalsOptions={{
                classes: 'black-friday-top-selects-1 !my-0'
              }}
              blackFriday={true}
              blackFridayBadge={'25% Off'}
              isSeventhImage={true}
              newArrivalsAllFeed={'nq-new-arrivals-all-feed'}
              newArrivalsClothingFeed={'nq-new-arrivals-clothing-feed'}
              newArrivalsFootwearFeed={'nq-new-arrivals-footwear-feed'}
              newArrivalsAccessoriesFeed={'nq-new-arrivals-accessories-feed'}
            />
          </div>

          {/* END OF SEASON SALE COMPONENTS */}
          <div className="flex flex-col gap-14 md:gap-28 pb-20 md:pb-32 mb-24 lg:mb-32 bg-blackFriday1">
            <Banner
              cta={'UP TO 60% OFF'}
              bfpDescription={'END OF SEASON SALE'}
              blackFridayPreview={true}
              blackFriday24={true}
              buttonLink={'sale/'}
              buttonLinkText={'Shop Now'}
              gaBlockTitle={'End of Season Sale Banner Button'}
              gaBlockName={'End of Season Sale'}
              gaBlockId={'end-of-season-sale-banner-button'}
              endSale25={true}
              endSale25BGVid={
                isMobile
                  ? 'https://www.sevenstore.com/images/src/images/sevenstore/sale/60-percent/eos-mob.webm'
                  : 'https://www.sevenstore.com/images/src/images/sevenstore/sale/60-percent/eos-desk.webm'
              }
              endSale25BGVidType={'video/webm'}
              endSale25Extra={true}
              endSale25ExtraImg="https://www.sevenstore.com/images/src/images/sevenstore/sale/sale-extra15-lockup-3.webp"
            />

            <CategoriesBrands
              data={componentData.bfCategories}
              gaBlockName={'End of Season Sale Categories'}
              categoryBrandOptions={{
                classes: 'categories-1'
              }}
              showCategoryBrand={true}
            />

            <CategoriesBrands
              data={componentData.bfBrands}
              gaBlockName={'End of Season Sale Brands'}
              categoryBrandOptions={{
                classes: 'brands-1'
              }}
              showCategoryBrand={true}
            />

            <NewArrivals
              gaBlockName={'End of Season Sale Carousel'}
              gaBlockNameClothing={'End of Season Sale Carousel Clothing'}
              gaBlockNameFootwear={'End of Season Sale Carousel Footwear'}
              gaBlockNameAccessories={'End of Season Sale Carousel Accessories'}
              newArrivalsHeading={'End of Season Sale Top Selects'}
              newArrivalsOptions={{
                classes: 'black-friday-top-selects-1 !my-0'
              }}
              blackFriday={true}
              blackFridayBadge={'End of Season Sale'}
              isSeventhImage={false}
              newArrivalsButtonLinkAll={'/sale/'}
              newArrivalsButtonLinkClothing={'/sale/?category_default_codes=am'}
              newArrivalsButtonLinkFootwear={'/sale/?category_default_codes=fm'}
              newArrivalsButtonLinkAcc={'/sale/?category_default_codes=cm'}
              newArrivalsAllFeed={'nq-new-arrivals-all-feed'}
              newArrivalsClothingFeed={'nq-new-arrivals-clothing-feed'}
              newArrivalsFootwearFeed={'nq-new-arrivals-footwear-feed'}
              newArrivalsAccessoriesFeed={'nq-new-arrivals-accessories-feed'}
            />
          </div>
        </>
      )}
    </section>
  );
};

export default App;
